const MessengerMenuTypes = {
    CHANNEL: {
        id: "detail",
        group: "settings_group",
        path: "detail",
        label: "Detail",
        tabs: [],
        implemented: true,
    },
    VISIBILITY: {
        id: "visibility",
        group: "settings_group",
        path: "visibility",
        label: "Visibility",
        tabs: [],
        implemented: true,
    },
    COMMENT_SETTINGS: {
        id: "commentsettings",
        group: "settings_group",
        path: "commentsettings",
        label: "Comment Settings",
        tabs: [],
        implemented: true,
    },
    AD_OPTIMIZATION: {
        id: "adoptimization",
        group: "settings_group",
        path: "ad-optimization",
        label: "Ad Optimization",
        tabs: [],
        implemented: true,
    },
};

export default MessengerMenuTypes;
